import * as React from 'react';

// Components
import GenericNavbar from '@tob/shared/components/GenericNavbar';

// Styles
import commonStyles from '../common.styles.scss';

type Props = {
  title?: string;
  rightContent?: React.ReactNode;

  onClickBack?: (event: React.SyntheticEvent) => void;
  shouldHideBack?: boolean;
  isResponsive?: boolean;
};

const Navbar = (props: Props): JSX.Element => {
  return (
    <GenericNavbar
      {...props}
      containerClassName={commonStyles.navBarContainer}
      titleClassName={commonStyles.navBarTitle}
      iconClassName={commonStyles.navBarIcon}
      rightContent={
        props.rightContent ? (
          <div className={commonStyles.navBarRightContent}>
            {props.rightContent}
          </div>
        ) : undefined
      }
    />
  );
};

export default Navbar;
